export default "__VITE_PUBLIC_ASSET__2b7ed265__"